<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>User Management Detail</strong>
        </div>
        <b-row style="vertical-align: middle;padding-bottom:5px;">
          <b-col md="5" class="d-inline-flex">
            <button class="btn btn-warning" @click="$router.go(-1)">
              <i title="Back" class="fa fa-arrow-left fa-lg text-white"></i> <strong class="text-white">Return to Users</strong>
            </button>
            <button class="btn btn-info ml-1" @click="saveUser">
              <i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong>
            </button>
            <button class="btn btn-success ml-1" @click="setDefaultPassword" v-if="user.user_id !== undefined">
              <i title="Set Default Password" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Set Default Password</strong>
            </button>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">

            <b-row class="my-1">
              <b-col md="4">
                <label>Username</label>
              </b-col>
              <b-col md="8">
                <div v-if="isAdmin">
                  <b-form-input required type="text" v-validate="{required: true, min: 1, max: 50, regex: /^[\w]+$/ }" v-model="user.login" name="Username"></b-form-input>
                </div>
                <div v-else>
                  <label>{{user.login}}</label>
                </div>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4">
                <label>Name</label>
              </b-col>
              <b-col md="8">
                <b-form-input type="text" v-validate="{required: true,min: 0, max: 100, regex: /^[\w\s']+$/ }" v-model="user.name" name="FirstName"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4">
                <label>Email</label>
              </b-col>
              <b-col md="8">
                <b-form-input type="email" v-validate="{required: true,email: true, min: 1, max: 40}" v-model="user.email" name="Email"></b-form-input>
              </b-col>
            </b-row>

          </b-col>
          <b-col md="4">
            <b-row class="my-1">
              <!--<span v-model="errors">{{ validateErrors.items }}</span>-->
              <b-list-group style="min-width:100%">
                <b-list-group-item class="py-2" variant="danger" v-for="err in validateErrors.items" :key="err.id"> {{ err.msg }} </b-list-group-item>
              </b-list-group>
            </b-row>
          </b-col>
        </b-row>

      </b-card>
      <b-card md="8">
        <div slot="header">
          <strong>User Applications</strong>
        </div>
        <!-- Main table element -->
        <b-table :items="FilteredRecords" :fields="gridfields" hover striped bordered small :current-page="currentPage" :sort-compare="onNewSort" :per-page="perPage" show-empty>
          <template slot="created_ts" slot-scope="data">
            {{ data.item.created_ts | formatDate }}
          </template>
         
          <template slot="disabled_ts" slot-scope="data">
            {{ data.item.disabled_ts | formatDate }}
          </template>
          <template slot="Actions" scope="data">
            <b-row>
              <b-col md="12">
                <!--<b-button class="btn btn-warning text-white ml-1" @click="disableApp(data.item)" >
                  <i class="fa fa-toggle-off" title="Active"></i> <strong class="text-white">Enable</strong>
                </b-button>
                <b-button  class="btn btn-success text-white ml-1" @click="enableApp(data.item)">
                  <i class="fa fa-toggle-on" title="Disable"></i> <strong class="text-white">Disable&nbsp;</strong>
                </b-button>-->
                <!--<b-form-checkbox size="lg" v-model="data.item.is_active" switch>Large</b-form-checkbox>-->
                <c-switch data-feature-code="data.item.app_id" v-model="data.item.is_active" type="text" variant="primary"
                                      on="On" off="Off" :pill="true" @change="switchApp(data.item)"/>
              </b-col>
            </b-row>
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount()" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>
      <div>

        <b-modal ref="bv-modal-disable"
                 title="Disable Application"
                 @hide="selectionBackModal()"
                >
          <template slot="modal-title">

          </template>

          <div class="d-block text-left">
            Application Name:  <h4>{{app_selected.name}}</h4>
          </div>
          <div class="d-block text-left">
            User Scope:<h4>{{app_selected.scope}} </h4>
          </div>
          <div class="d-block text-left warning ">
            <h2>{{msgVModal}}</h2>
          </div>
          <div slot="modal-footer" class="w-100">
            <!--<p class="float-left">Modal Footer Content</p>-->
            <b-button v-if="btnSave" variant="primary"
                      ref="enaFormSave"
                      size="sm"
                      class="float-right m-2"
                      @click="disableForm()">
              Save
            </b-button>
            <b-button v-if="btnClose" variant="primary"
                      ref="enaFormClose"
                      size="sm"
                      class="float-right m-2"
                      @click="closeDisableForm()">
              Close
            </b-button>
          </div>
        </b-modal>

        <b-modal ref="bv-modal-enable"
                 v-model="showEnableForm"
                 title="Enable Application"
                 @hide="selectionBackModal()">

          <div class="d-block text-left">
            Application Name: <h4>{{app_selected.name}}</h4>
          </div>

          <form ref="formEnable" @submit.stop.prevent="handleSubmitEnable">
            <b-form-group :state="nameState"
                          invalid-feedback="role is required">
              <div class="d-block text-left">
                Current Scope: {{selected_role}}
                <b-form-select v-model="selected_role"
                               label="role"
                               label-for="role-input"
                               :options="roles"
                               :state="nameState"
                               required></b-form-select>

              </div>
              <div class="d-block text-left" v-if="app_selected.needs_sid">
                Enter or Update SID:
                <b-form-input v-model="app_selected.sid" placeholder="Enter SID"></b-form-input>
              </div>
            </b-form-group>
          </form>



          <div class="d-block text-left">
            This action will allow this user uses <stron>{{app_selected.name}}</stron> app.
          </div>
          <div class="d-block text-left warning ">
            <h2>{{msgVModal}}</h2>
          </div>
          <div slot="modal-footer" class="w-100">
            <!--<p class="float-left">Modal Footer Content</p>-->
            <b-button v-if="btnSave" variant="primary"
                      ref="enaFormSave"
                      size="sm"
                      class="float-right m-2"
                      @click="enableForm()">
              Save
            </b-button>
            <b-button v-if="btnClose" variant="primary"
                      ref="enaFormClose"
                      size="sm"
                      class="float-right m-2"
                      @click="closeForm()">
              Close
            </b-button>
          </div>
        </b-modal>

      </div>

    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
  import Vue from 'vue';
  import store from '@/store'
  import axios from 'axios';
  import loading from 'vue-full-loading';
  import { setTimeout } from 'timers';
  import VeeValidate from 'vee-validate';
  import moment from 'moment'
  import cSwitch from '../components/Switch'

  export default {
    components: {
      loading,
      cSwitch
    },
    created() {
      var self = this;
      if (this.$route.params.userId && parseInt(this.$route.params.userId) !== -1) {

        axios.get('/api/UserManagement/Get?userId=' + this.$route.params.userId)
          .then(response => {
            this.boolLoading = false;
            if (response.data === undefined || response.data === null) {
              this.user = {};
            } else {
              this.user = response.data;
            }
          })
          .catch(error => {
            if (error.response.status == 403)
              this.$router.push('/login');

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          });

        this.fetchData(this.$route.params.userId);
        this.getRoles();

      } else {
        setTimeout(function () {
          self.user = {};
          self.boolLoading = false;
        }, 500);
      }
    },
    filters: {
      formatDate: function (date) {
        var m = moment(date)
        if (m.isValid()) {
          return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
        }
        return ''
      },
      formatAccessDisplay: function (accessBool) {
        var display = 'No'
        if (accessBool) {
          display = 'Yes'
        }
        return display;
      }
    },
    data() {
      return {
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        user: {},
        apps_user:[],
        myinput: '',
        totalCount: 0,
        tbxFilter: '',
        gridfields: [
          { key: 'app_id', label: 'ID', sortable: true },
          { key: 'name', label: 'App', sortable: true },
          { key: 'scope', label: 'Scope', sortable: true },
          { key: 'created_ts', label: 'Created', sortable: true },          
          { key: 'disabled_ts', label: 'Disabled_ts', sortable: true },
          { key: 'Actions', label: '', sortable: false }
        ],
        roles:[],
        selected_role: null,
        app_selected: {},
        msgVModal: "",
        showOk: true,
        btnSave:true,
      }
    },

    methods: {
      selectionBackModal() {
        this.app_selected.is_active = !this.app_selected.is_active;
      },
      enableForm() {

        if (this.app_selected.needs_sid == true && this.app_selected.sid.length == 0) {
          
          this.msgVModal = 'Error: You must add a SID key for this user.';
          setTimeout(() => {
            this.msgVModal = '';
            this.showOk = true;
            return;
          }, 5000);
        }
        else {
          axios.get('/api/UserManagement/SetAppUserPermission?user_id=' + this.$route.params.userId + "&app_id=" + this.app_selected.app_id + "&scope=" + this.selected_role + "&sid=" + this.app_selected.sid)
            .then(response => {
              this.btnSave = false;
              this.btnClose = false;
              this.boolLoading = false
              this.setResult = response.data;
              this.msgVModal = 'Permission is granted!'
              this.fetchData(this.$route.params.userId);
              setTimeout(() => {
                this.msgVModal = '';
                this.$nextTick(() => {
                  this.$refs['bv-modal-enable'].hide()
                });
                this.showOk = true;
              }, 2000);

            })
            .catch(error => {
              if (error.response.status === 403) { this.$router.push('/login') }
              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
              this.showOk = true
              this.app_selected.is_active = !this.app_selected.is_active;
            })
        }
        //this.app_selected.is_active = !this.app_selected.is_active;
        //this.$refs['bv-modal-enable'].hide()
      },
      disableForm() {
        axios.get('/api/UserManagement/DisableAppUserPermission?user_id=' + this.$route.params.userId + "&app_id=" + this.app_selected.app_id)
          .then(response => {
            this.btnSave = false;
            this.btnClose = false;
            this.boolLoading = false
            this.setResult = response.data;
            this.msgVModal = 'Permission is disabled!';
            this.fetchData(this.$route.params.userId);
            setTimeout(() => {
              this.msgVModal = '';
              this.$nextTick(() => {
                this.$refs['bv-modal-disable'].hide()
              })
              this.showOk = true;
            }, 3000);

          })
          .catch(error => {
            if (error.response.status === 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
            this.showOk = true;
            this.app_selected.is_active = !this.app_selected.is_active;
          })
       
        //this.app_selected.is_active = !this.app_selected.is_active;
        //this.$refs['bv-modal-enable'].hide()
      },
      closeForm() {
        this.$refs['bv-modal-enable'].hide()
      },
      closeDisableForm() {
        this.$refs['bv-modal-disable'].hide()
      },
      SetAppUserPermission() {
        this.showOk = false;
        if (this.app_selected.needs_sid == true && this.app_selected.sid.length == 0) {
          this.msgVModal = 'Error: You must add a SID key for this user.';
          setTimeout(() => {
            this.msgVModal = '';
            this.showOk = true;
            return;
          }, 5000);
        }
        else {
          axios.get('/api/UserManagement/SetAppUserPermission?user_id=' + this.$route.params.userId + "&app_id=" + this.app_selected.app_id + "&scope=" + this.selected_role + "&sid=" + this.app_selected.sid)
            .then(response => {
              this.boolLoading = false
              this.setResult = response.data;
              this.msgVModal = 'Permission is granted!'
              this.fetchData(this.$route.params.userId);
              setTimeout(() => {
                this.msgVModal = '';
                this.$nextTick(() => {
                  this.$refs['bv-modal-enable'].hide()
                });
                this.showOk = true;
              }, 3000);

            })
            .catch(error => {
              if (error.response.status === 403) { this.$router.push('/login') }
              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
              this.showOk = true
            })
        }
        
       
      },
      DisableAppUserPermission() {
        this.showOk = false;
        axios.get('/api/UserManagement/DisableAppUserPermission?user_id=' + this.$route.params.userId + "&app_id=" + this.app_selected.app_id)
          .then(response => {
            this.boolLoading = false
            this.setResult = response.data;
            this.msgVModal = 'Permission is disabled!';
            this.fetchData(this.$route.params.userId);
            setTimeout(() => {
               this.msgVModal = '';
               this.$nextTick(() => {
                  this.$refs['bv-modal-disable'].hide()
               })
              this.showOk = true;
            }, 3000);
           
          })
          .catch(error => {
            if (error.response.status === 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
            this.showOk = true;
          })
        
       
      },
      switchApp(app) {
        this.btnSave = true;
        this.btnClose = true;;
        this.app_selected = app;
        if (app.is_active == false) {
          this.disableApp(app);
        }
        else {
          this.enableApp(app);
        }
        //console.log("Action", item);
      },
      disableApp(app) {
        this.app_selected = app;
        this.$refs['bv-modal-disable'].show()
      },
      enableApp(app) {
        this.app_selected = app;
        
        if (this.roles.length > 0) {
          this.selected_role = this.roles[0].value;
        }
        this.$refs['bv-modal-enable'].show()
      },
      getRowCount() {
        return this.FilteredRecords.length
      },
      fetchData(user_id) {
        axios.get('/api/UserManagement/GetAppsUser?user_id=' + user_id)
          .then(response => {
            this.boolLoading = false
            this.apps_user = response.data.apps_user
            this.totalCount = this.apps_user.length
          })
          .catch(error => {
            if (error.response.status === 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          })
      },
      getRoles() {
        axios.get('/api/UserManagement/GetRoles')
          .then(response => {
            this.boolLoading = false
            this.roles = response.data.roles;
            
          })
          .catch(error => {
            if (error.response.status === 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          })
      },
      saveUser(p) {
        var self = this;

        this.$validator.validateAll().then((result) => {
          if (result) {
            var obj = {
              user_id: self.user.user_id,
              login: self.user.login,
              name: self.user.name,
              email: self.user.email,
            };

            axios.post('/api/UserManagement/Save', obj)
              .then(response => {
                self.errMsg = 'Your changes has been saved'
                self.dismissibleType = 'success'
                self.showDismissibleAlert = true
                self.boolLoading = false

                if (self.user.user_id === undefined) {
                  self.user["user_id"] = parseInt(response.data);
                }
                self.$router.replace(`/UserManagementDetail/${response.data}`);
              })
              .catch(error => {
                if (error.response.status == 403) {
                  self.$router.push('/login');
                }

                self.boolLoading = false

                self.errMsg = 'There was an error saving your changes : '
                if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                  self.errMsg = self.errMsg + error.response.statusText
                } else {
                  self.errMsg = self.errMsg + error
                }

                self.showDismissibleAlert = true
              });
          } else {
            //alert('Please correct errors first');

            self.errMsg = 'Please correct errors first';
            self.dismissibleType = 'danger';
            self.showDismissibleAlert = true

            setTimeout(function () {
              self.showDismissibleAlert = false;
              self.errMsg = '';
            }, 8000);
          }
        });

        
      },
      setDefaultPassword(p) {
        var self = this;

        self.$dialog.confirm('Are you sure you would like to reset password to default \'password\'?')
          .then(function () {
            var obj = {
              user_id: self.user.user_id
            };

            axios.post('/api/UserManagement/SetDefaultPassword', obj)
              .then(response => {

                self.errMsg = 'User\'s password was set to \'password\''
                self.dismissibleType = 'success'
                self.showDismissibleAlert = true
                self.boolLoading = false
              })
              .catch(error => {
                if (error.response.status == 403) {
                  self.$router.push('/login');
                }

                self.boolLoading = false

                self.errMsg = 'There was an error resetting password to default : '
                if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                  self.errMsg = self.errMsg + error.response.statusText
                } else {
                  self.errMsg = self.errMsg + error
                }

                self.showDismissibleAlert = true
              });

          })
          .catch(function () {
            //do nothing
          })
      },
    },
    computed: {
      isAdmin: function () {
        return store.state.currentRole == 'Admin';
      },
      FilteredRecords: function () {
        if (this.boolLoading) {
          return []
        } else {
            return this.apps_user          
        }
      }
    },
    mounted() {
      //boolLoading must be set to false on data() binding so that mount hooks the change
      this.boolLoading = true;
    }
  }
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/UserManagementDetail.vue